import { useEffect, EffectCallback, DependencyList } from 'react';
import useSelectedBusiness from '../business/useSelectedBusiness';

export default function useBusinessEffect(effect: EffectCallback, dependencies: DependencyList) {
  const business = useSelectedBusiness();

  useEffect(effect, [business?.businessId, ...dependencies]);
}
